import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'app-public',
    templateUrl: './public.component.html',
    styleUrls: ['./public.component.sass'],
    standalone: false
})
export class PublicComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit(): void {
  }

}
